import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AuthenticationResult } from '../../../clients'

interface CognitoAccessTokenPayload {
  sub: string,
  'cognito:groups': string[],
  iss: string
  version: 2,
  client_id: string
  origin_jti: string
  token_use: string
  scope: string
  auth_time: number,
  exp: number,
  iat: number,
  jti: string
  username: string
}

interface CognitoIdTokenPayload {
  sub: string
  'cognito:groups': string[]
  email_verified: boolean
  'custom:username': string
  'iss': string
  'cognito:username': string
  'origin_jti': string
  aud: string
  token_use: 'id'
  auth_time: number
  exp: number
  iat: number
  jti: string
  email: string
}

interface AuthState {
  pending: boolean
  data: AuthenticationResult | null
  accessTokenPayload: CognitoAccessTokenPayload | null
  idTokenPayload: CognitoIdTokenPayload | null
}

const initialState: AuthState = {
  pending: true,
  data: null,
  accessTokenPayload: null,
  idTokenPayload: null,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    authenticate(state, payload: PayloadAction<AuthenticationResult | null>) {
      state.pending = false
      state.data = payload.payload
      if (payload.payload && payload.payload.accessToken) {
        state.accessTokenPayload = JSON.parse(atob(payload.payload.accessToken.split('.')[1]))
      } else {
        state.accessTokenPayload = null
      }
      if (payload.payload && payload.payload.idToken) {
        state.idTokenPayload = JSON.parse(atob(payload.payload.idToken.split('.')[1]))
      } else {
        state.idTokenPayload = null
      }
    },
    updateAuthentication(state, payload: PayloadAction<AuthenticationResult | null>) {
      state.data = payload.payload
    }
  }
})

export const { authenticate, updateAuthentication } = authSlice.actions
export default authSlice.reducer